import styled from '@emotion/styled';
import * as React from '@emotion/react';
import { NUM_OF_CARDS } from '../utils/constants';
import { PaginationContainerProps } from '../models/card-props';
import { BG_COLOR_PROPERTIES } from '../models/colors-props';

export function PaginationContainer({
  selectedMedia,
  colorCoding
}: PaginationContainerProps) {
  return (
    <PaginationContainerRoot
      selectedMedia={selectedMedia}
      colorCoding={colorCoding}
    >
      {renderCardDots(colorCoding)}
    </PaginationContainerRoot>
  );
}

const renderCardDots = (colorCoding: BG_COLOR_PROPERTIES) => {
  const cardDotList = [];
  for (let cardId = 1; cardId <= NUM_OF_CARDS; cardId++) {
    cardDotList.push(
      <CardDots
        key={cardId}
        className={`cardDot cardDot${cardId}`}
        colorCoding={colorCoding}
      />
    );
  }
  return cardDotList;
};

export const PaginationContainerRoot = styled.div<{
  selectedMedia: number;
  colorCoding: BG_COLOR_PROPERTIES;
}>`
  flex-basis: inherit;
  height: 12px;
  min-width: 100%;
  margin-top: 32px;
  margin-bottom: 32px;
  display: none;
  align-items: center;
  justify-content: center;

  @media only screen and (max-width: 767px) {
    display: flex;

    .cardDot {
      background-color: ${(props) => props.colorCoding.paginationColorInactive};
    }

    .cardDot.cardDot${(props) => props.selectedMedia} {
      background-color: ${(props) => props.colorCoding.paginationColorActive};
    }
  }
`;

export const CardDots = styled.div<{ colorCoding: BG_COLOR_PROPERTIES }>`
  margin-left: 6px;
  margin-right: 6px;
  width: 8px;
  height: 8px;
  border-radius: 50%;
`;
